// extracted by mini-css-extract-plugin
export default {"video":"styles_video__UF034","desc":"styles_desc__WjHL2"};